.notice {
  padding: 9.75px;
  font-size: 13px;
  font-weight: 600;
  color: #e6160f;
  text-align: center;
  border: 1px solid #e6160f;
  border-radius: 8px;

  > span {
    display: inline-block;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    font-size: 15px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    font-size: 15px;
  }
}
